module.exports = __webpack_public_path__ + "img/tools.5b0aa518.png";